import React from 'react';
import S from '../../UmbracoForm.styles';
const RichText = ({ field }) => {
    if (!field.settings?.html) {
        return null;
    }
    return (React.createElement(S.Field, null,
        React.createElement(S.RichText, { dangerouslySetInnerHTML: { __html: field.settings.html } })));
};
RichText.displayName = 'RichText';
export default RichText;
